import * as React from 'react'
import { FC, useMemo } from 'react'
import { useTabData } from '@user/components/Location/MatchCreateNew/hooks/useTabData'
import { ENTITY_TYPES } from '@sales-center/common'
import { Formik } from 'formik'
import { CreateServiceLocationFormModel } from './utility/types'
import { CreateLocationForm } from './CreateLocationForm'
import { useLocationHandlers } from './hooks/useLocationHandlers'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  title: string
  onCloseNewLocation: () => void
  onNewLocationsSave: () => void
  tidalThemeActive?: boolean
  containerTop?: string
  addToPestPac?: boolean
}

export const CreateLocationFormWrapper: FC<Props> = (props) => {
  const {
    entityId,
    entityType,
    title,
    onCloseNewLocation,
    onNewLocationsSave,
    containerTop,
    addToPestPac,
  } = props

  const { validate, setInitialTouched } = useLocationHandlers(addToPestPac)
  const { invalidLocations } = useTabData()

  const initialValues = useMemo(() => {
    return {
      entityId,
      entityType,
      locations: invalidLocations.reduce(
        (acc: { [key: string]: CreateServiceLocationFormModel }, curr) => {
          acc[curr.id] = curr
          return acc
        },
        {} as { [key: string]: CreateServiceLocationFormModel },
      ),
    }
  }, [entityId, entityType, invalidLocations])

  const initErrors = useMemo(() => {
    return validate(initialValues)
  }, [validate, initialValues])

  const initialTouched = useMemo(() => {
    return setInitialTouched(initErrors)
  }, [initErrors, setInitialTouched])

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={validate}
        initialErrors={initErrors}
        initialTouched={initialTouched}
        onSubmit={onNewLocationsSave}
      >
        <CreateLocationForm
          {...props}
          invalidLocations={invalidLocations}
          onCloseNewLocation={onCloseNewLocation}
          title={title}
          containerTop={containerTop}
        ></CreateLocationForm>
      </Formik>
    </>
  )
}
CreateLocationFormWrapper.displayName = 'CreateLocationFormWrapper'
